import { ThemeKeys } from '@view/login/themes/themeData'

export type ContextInitState = {
	currentBusinessAddressAsString: string
	bowaterRegNumber: string
	init?: boolean
	userContext?: string
	context?: string
	dashType?: 'oui' | 'cui' | 'sui' | 'dui' | 'cui-flex'
	dashQuickLinksOptions?: Services[]
	currentBusinessId?: string
	currentBusiness?: string
	currentBusinessAddress?: string
	personId?: string
	personFullName?: string
	permissions?: Permissions
	operatorName: string
	operatorEmailAddress: string
	operatorTelephoneNumber: string
	operatorId?: string
	userName?: string
	siteTheme: ThemeKeys
	supplierLogo: string
	sessionData?: string
	userRoleName?: string
	userLocation?: null | { latitude: number; longitude: number }
	countryId?: string
	id?: string
	memberAreaBusinessSwapper?: boolean
	memberAreaBusinessSwapperDefault?: string
	memberAreaBusinessSwapperOptions?: []
	memberAreaBusinessSwapperText?: string
	memberAreaLinks?: { [key: string]: string }[]
	rentalTeamSwapperOptions?: {
		value: [key?: string]
		rentalTeams: {
			key: string
			value: string
			text: string
			selected: boolean
		}[]
	}
	countryCode?: string
	currencyCode?: string
	currency: 'GBP' | 'EUR' | 'USD' // add more as more are added to db
	driverId: string | null
	loading?: boolean
	driver?: {
		id: string
		name: string
		email: string
	}
	cancelNetworkRequests: boolean
	weglotApiKey: string
	labels: Labels
	userDefaultSearchCategory?: string
}

export interface Labels {
	motFieldLabel?: string
	p11dLabel?: string
}

export type NewResPermissions = Record<'cui' | 'oui' | 'cui-flex', boolean>

export type Permissions = Record<PermissionsKeys, boolean>

type PermissionsKeys =
	| 'rental_admin_manager.all_other_fines'
	| 'rental_admin_manager.billing'
	| 'rental_admin_manager.customer_services'
	| 'rental_admin_manager.damage_manager'
	| 'rental_admin_manager.drivers'
	| 'rental_admin_manager.parking_fines'
	| 'rental_admin_manager.reports'
	| 'rental_admin_manager.speeding_fines'
	| 'rental_admin_manager.view_approval'
	| 'rental_manager.all_reservations'
	| 'rental_manager.live_reservations'
	| 'reservation_manager.new_reservation'
	| 'rental_manager.tbas'
	| 'rental_reservation.edit_purchase_order'
	| 'reservation_manager.quote'
	| 'reservation_manager.turned_down'
	| 'user.inactive_search'
	| 'user_management.all'
	| 'user_management.self'
	| 'rental_admin_manager.suppliers'
	| 'rental_admin_manager.didYouKnow'
	| 'rental_admin_manager.customers'
	| 'rental_manager.new_reservation'
	| 'newResAccess'
	| 'reservationLimitedBooker'
	| 'rental_admin_manager.fine_manager'
	| 'lockDriver'
	| 'lockBooker'
	| 'lockNewDriver'
	| 'driver_manager.new_pool_reservation'
	| 'reservation_manager.new_pool_reservation'
	| 'rental_manager.new_pool_reservation'
	| 'fodPoolAccess'
	| 'editRes'
	| 'rental_manager.book_taxi'
	| 'offerFodRide'
	| 'offerUber'
	| 'hasPoolFleetAccessOnly'
	| 'hasPoolFleetAndRentalAccess'
	| 'canAddReservationDocuments'

type Services =
	| 'Customer Services'
	| 'Damage Manager'
	| 'Billing'
	| 'Reporting'
	| 'Did you know?'
	| 'Billing with links'
	| 'Suppliers'
	| 'Vehicle'
